export const initialNewsState = {
    dataNews: null,
    loading: false,
    error: null,
};
